import {RichTextEditor} from '@/components';

const RichTextEditorFormik = ({ field, form, ...props }) => {
    const handleChange = (html) => {
        form.setFieldValue(field.name, html);
    };

    return (
        <div className="w-full">
        <RichTextEditor value={field.value} onChange={handleChange} {...props} />
        {form.touched[field.name] && form.errors[field.name] && (
            <div className="text-red-500 text-sm mt-1">
            {form.errors[field.name]}
            </div>
        )}
        </div>
    );
}

export { RichTextEditorFormik }